<template>
  <div class="group" :class="{ 'group__expand': expand }">
    <span class="group-join" @click="changeLogic" @mousedown.prevent>
      {{ getLogicStr() }}
    </span>
    <span class="group-expand" @mousedown.prevent v-if="!data.$isRoot">
      <DsfIcon name="jia" v-if="!expand" @click.stop="expandHandler" title="展开"></DsfIcon>
      <DsfIcon name="jian" v-else @click.stop="expandHandler" title="折叠"></DsfIcon>
    </span>
    <div class="group-box" v-show="expand">
      <div class="group-brackets"></div>
      <div class="items">
        <template v-for="(item, $index) in data.items">
          <split :key="item.$hash + '—before'" :data="item" pos="before"></split>
          <DsfCustomDropTreeLogicNode :key="item.$hash" :data="item">
            <template #default="{data}">
              <slot :data="data"></slot>
            </template>
          </DsfCustomDropTreeLogicNode>
          <split v-if="$index == data.items.length - 1" :key="item.$hash + '-after'" :data="item" pos="after">
          </split>
        </template>
      </div>
    </div>
    <div class="group-box-contract" v-show="!expand" @click.stop="expandHandler">
      <span title="展开">{{ data.items.length + '个子条件' }}</span>
    </div>
  </div>
</template>
<script>
import split from "./split.vue"
export default {
  name: "group",
  components: {
    split
  },
  inject: {
    $customDropTree: {
      default: null
    }
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
          items: []
        };
      }
    }
  },
  data() {
    return {
      expand: true
    };
  },
  created(){
    if(!this.data.logic){
      this.data.logic = this.$customDropTree.defaultLogic;
    }
  },
  methods: {
    changeLogic() {
      this.data.logic = this.$customDropTree.changeLogic(this.data);
    },
    getLogicStr() {
      return this.$customDropTree.logic[this.data.logic];
    },
    expandHandler() {
      this.expand = !this.expand;
    }
  },
  watch: {
    'data.items'(v,old) {
      this.$nextTick(() => {
        this.$customDropTree.buildTreeRelation()
      })
    }
  }
};
</script>